import React, { ReactElement, Fragment } from 'react';
import { Box } from '@mui/material';

import { InspectionDataGrid } from 'components/inspection/InspectionDataGrid';
import { composeHOCs } from 'shared/utils/composeHOCs';
import { withProcessesData } from 'components/common/withProcessesData';
import { useInspectionDataGridRows, withInspectionListStore } from 'store/inspection';
import { WithDataGridApi } from 'components/common/withDataGridApi';
import { useInspectionsWithSearch } from 'store/search/searchStore.inspections';
import { InspectionToolbar } from 'components/inspection/InspectionDataGrid/InspectionToolbar';

function Inspections(): ReactElement {
  const { rows, loading } = useInspectionDataGridRows();
  const { filteredData, searchPhrase, InspectionSearchInput } =
    useInspectionsWithSearch(rows);

  return (
    <WithDataGridApi>
      <Fragment>
        <InspectionToolbar SearchInput={InspectionSearchInput} />
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            overflowY: 'hidden',
            overflowX: 'hidden',
            display: 'flex',
            flex: 1,
          }}
        >
          <Box
            sx={{
              width: '100%',
              position: 'absolute',
              height: '100%',
              display: 'flex',
              flex: 1,
            }}
          >
            <InspectionDataGrid
              data={filteredData}
              loading={loading && filteredData.length === 0}
              searchPhrase={searchPhrase}
            />
          </Box>
        </Box>
      </Fragment>
    </WithDataGridApi>
  );
}

export const MemoInspections = React.memo(
  composeHOCs(
    withProcessesData,
    withInspectionListStore
  )(Inspections)
);
